import * as React from "react";
import { connect } from "react-redux";
import { Link, withRouter } from "react-router-dom";
import * as Tools from "../../helpers/Tools";
import { logUI } from '../../api/andyliticsApi';
import * as queryString from 'query-string';
import OpenScheduleDateOnly from "./OpenScheduleDateOnly";

class OpenScheduleButton extends React.Component {

    constructor() {
        super();
        this.formatTimeString = this.formatTimeString.bind(this);
        this.formatRoute = this.formatRoute.bind(this);
    }

    formatTimeString(s, dayString, timeValue) {
        if (!s) return;
        const today = new Date();
        let dateTime = s.split("T");
        const dt = new Date(s);
        let time = (dateTime.length > 0) ? dateTime[1].split(":") : "00:00:00";
        if (time.length > 0) {
            dt.setHours(time[0], time[1]);
        }
        // const dt = new Date(s.replace(/\s/, 'T'));
        let isToday = false;
        let AMPM = dt.getHours() >= 12 ? "PM" : "AM";
        let timeStr = timeValue ? timeValue : `${(dt.getHours() > 12 ? dt.getHours() - 12 : dt.getHours())}:${dt.getMinutes().toString().padStart(2, "0").slice(-2)} ${AMPM}`;

        if (today.getDate() === dt.getDate() && today.getMonth() === dt.getMonth() && today.getFullYear() === dt.getFullYear()) {
            isToday = true;
        }

        let dow = "Today";
        if (!isToday) {
            switch (dt.getDay()) {
                case 0: dow = "Sun."; break;
                case 1: dow = "Mon."; break;
                case 2: dow = "Tue."; break;
                case 3: dow = "Wed."; break;
                case 4: dow = "Thu."; break;
                case 5: dow = "Fri."; break;
                case 6: dow = "Sat."; break;
            }
        }

        //timeStr = `${timeStr} | ${dow}`;

        let month = "";
        switch (dt.getMonth()) {
            case 0: month = "JAN"; break;
            case 1: month = "FEB"; break;
            case 2: month = "MAR"; break;
            case 3: month = "APR"; break;
            case 4: month = "MAY"; break;
            case 5: month = "JUN"; break;
            case 6: month = "JUL"; break;
            case 7: month = "AUG"; break;
            case 8: month = "SEP"; break;
            case 9: month = "OCT"; break;
            case 10: month = "NOV"; break;
            case 11: month = "DEC"; break;
        }

        //timeStr = `${timeStr} ${month} ${dt.getDate()}`;

        let timeHtml = <span><span className="appt-time">{timeStr} </span> <span className="appt-divider">| </span> <span className="appt-day">{dow} </span> <span className="appt-date">{month} {dt.getDate()}</span></span>;

        if (dayString === "Today") {
            timeHtml = <span><span className="appt-time">{timeStr} </span> <span className="appt-divider">| </span><span className="appt-date">{dayString}</span></span>;
        }
        if (this.props.isVaccineSearch) {
            timeHtml = <span className="appt-time">{timeStr} </span>;
        }
      

        return timeHtml;
    }

    formatRoute(npi, epicId, time, visitTypeId, departmentId, isVaccineSearch, scheduleData,isMammogram) {
        // time is in the form "2019-03-13T09:00:00"
        ///schedule/:npi/:visitTypeId?/:departmentId?/:date?/:time?
        const { providerSearchModel, bypassProxyAndInfo, date } = this.props;
        let ret = '';
        // let formatedDate = date ? date.split("T")[0] : '';
        if (isVaccineSearch) {
            ret = `/covidvaccine/schedule?visitTypeId=${visitTypeId}&provId=${epicId}&departmentId=${departmentId}&stime=${scheduleData.startTime}&etime=${scheduleData.endTime}`
            if (providerSearchModel && providerSearchModel.location) ret += `&loc=${providerSearchModel.location}`;
        } 
        else  {
            let d = "";
            let t = "";
            if (isMammogram) {
                ret = `services/mammogram/schedule/${npi}`;
            }
            else {
                ret = npi ? `/schedule/${npi}` : `/schedule?epicId=${epicId}`;

            }
            
            if(time !== undefined){
                let parts = time && time.split("T");
                if (parts.length > 0) {
                    d = parts[0];
                    t = parts[1];
                }
            }

            if (visitTypeId !== "" && !isNaN(visitTypeId)) {
                ret += npi ? `/${visitTypeId}` : `&visitTypeId=${visitTypeId}`;

                if (departmentId !== "") {
                    ret += npi ? `/${departmentId}` : `&departmentId=${departmentId}`;
                }

                if (d !== "" && t !== "") {
                    ret += npi ? `/${d}/${t}/` : `&date=${d}&time=${t}`;
                } else {
                    if (date) {
                        let parts = date && date.split("T");
                        if (parts && parts.length > 0) {
                            d = parts[0];
                        }
                        ret += npi ? `/${d}` : `&date=${d}`;
                    }
                }
            }
           
        }

        return ret;
    }
    
    getDateOnlyValue(dayString, dateString, isMammogram) {
        let dayValue = dayString;
        let dateLabel = "";
        const dateStr = dateString.split(' ');
        if (dayValue && dayValue !== "Today") {
            dayValue = dayString.substring(0, 3);
        }
        if (isMammogram) {
            const dateData = dateString.split(' ');
            dateLabel = Tools.getMonthNumber(dateString) + '/' + dateData[1];
        } else {
            
            dateLabel = <><span className="date-btn__month">{dateStr[0]} </span><span className="date-btn__date">{dateStr[1]}</span></>;
        }
        let timeStr = <span><span className="appt-time-date-only">{dayValue}</span><span className="appt-divider"> - </span><span className="appt-date-date-only">{dateLabel} </span></span>

        if (dayValue === "Today" && isMammogram) {
            timeStr = <span><span className="appt-time-date-only">{dayValue}</span></span>
        }

        return timeStr;
    }

    render() {
        const { isVaccineSearch, provAddress, isMammogram, initiateRetry, location, dayString, dateString, serverData, bypassProxyAndInfo, scheduleCampaignReferrer, isProviderMapPinView, showMobileMonthHeading} = this.props;
        const dateOnly =  isMammogram || (this.props.scheduleData && this.props.scheduleData.time == null && dayString && dateString && serverData && serverData.enableV3SearchForAllProviders );
        const scheduleCampaignActivity = scheduleCampaignReferrer ? { scheduleCampaignReferrer: scheduleCampaignReferrer } : {};
        return (
            <>{dateOnly
                ? <OpenScheduleDateOnly
                    label={this.getDateOnlyValue(dayString, dateString, isMammogram)}
                    month={dateString.substring(0, 3)}
                    isProviderMapPinView={isProviderMapPinView}
                    showMobileMonthHeading={showMobileMonthHeading}
                />
                : <div className={"date-btn"}>
                    <button className={"btn btn-primary" + (isVaccineSearch ? " covid-schedule-btn" : "")}
                        onClick={(e) => {
                            e.preventDefault();
                            e.stopPropagation();
                            logUI("MBHWeb.UI.FindCareResults.OpenScheduleLinkClicked", new Date(), Tools.getURLPath(), scheduleCampaignActivity, isVaccineSearch ? 'isVaccineSearch' : '');
                            //window.location.href = formatRoute(props.npi, props.scheduleData.time, props.scheduleData.visitTypeId, props.scheduleData.departmentId);
                            if (initiateRetry) initiateRetry();
                            let history = this.props.history;
                            let route = this.formatRoute(this.props.npi, this.props.epicId, this.props.scheduleData.time, this.props.scheduleData.visitTypeId, this.props.scheduleData.departmentId, isVaccineSearch, this.props.scheduleData, isMammogram);
                            let routeState = {};
                            let routeToSearch = null;
                            let searchString = '';
                            if (bypassProxyAndInfo) {
                                searchString = `bypassProxyAndInfo=${bypassProxyAndInfo}`
                            }
                            if (isVaccineSearch) {
                                const searchParams = location && location.search ? queryString.parse(location.search) : null;
                                const xid = searchParams && searchParams.xid ? searchParams.xid : null;
                                routeToSearch = route; //{ pathname: route, state: { noSelectPatient: true, isVaccineSearch: true } };
                                routeState = { provAddress: provAddress, scheduleData: this.props.scheduleData, xid: xid, scheduleCampaignReferrer: scheduleCampaignReferrer };
                            }
                            else {
                                routeToSearch = { pathname: route, search: searchString };
                                routeState = { scheduleCampaignReferrer: scheduleCampaignReferrer };
                            }
                            history.push(routeToSearch, routeState);
                        }}
                    >
                        {isVaccineSearch ? this.formatTimeString(this.props.scheduleData.startTime, this.props.dayString, this.props.scheduleData.timeString)
                            : this.formatTimeString(this.props.scheduleData.time, this.props.dayString, null)}
                    </button>
                </div>
              }
            </>
        );
    }
}


const mapStateToProps = (state, ownProps) => {
    return {
        history: state.session.history,
        providerSearchModel: state.providers.searchModel,
        serverData: state.session.serverData,      
        ...ownProps
    };
};

const mapDispatchToProps = (dispatch) => {
    return {};
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(OpenScheduleButton));
